import { connect } from 'react-redux';

import Uber from '../components/User/Uber';

import { getUberx } from '../redux/apply';

const mapDispatchToProps = dispatch => ({
  getUberx: uberx_status => dispatch(getUberx(uberx_status)),
});

export default connect(null, mapDispatchToProps)(Uber);



// WEBPACK FOOTER //
// ./src/containers/Uber.js